var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21V17H0V11C0 10.15 0.291667 9.43733 0.875 8.862C1.45833 8.28667 2.16667 7.99933 3 8H17C17.85 8 18.5627 8.28767 19.138 8.863C19.7133 9.43833 20.0007 10.1507 20 11V11.75C19.4 11.4167 19 11 19 11C19 10.6143 19 9 18 9H2C0.875 9.39442 1 10.5 1 11V16H4L4 13H12.5C12.3577 13.1512 11.3211 13.7955 11.25 14H5V20H11.1C11.1146 20.046 11.8952 20.7045 12.125 21H4ZM15 8V4L5 4V8H4V3H16V8L15 8Z",
    fill: "#3F2F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.5L19.5833 20.575C19.4815 20.7083 19.3496 20.8125 19.1878 20.8875C19.0259 20.9625 18.8522 21 18.6667 21H13.1111C12.8056 21 12.5439 20.902 12.3261 20.706C12.1083 20.51 11.9996 20.2747 12 20V15C12 14.725 12.1089 14.4895 12.3267 14.2935C12.5444 14.0975 12.8059 13.9997 13.1111 14H18.6667C18.8519 14 19.0256 14.0375 19.1878 14.1125C19.35 14.1875 19.4819 14.2917 19.5833 14.425L22 17.5ZM20.6389 17.5L18.6667 15H13.1111V20H18.6667L20.6389 17.5ZM13.1111 17.5V20V15V17.5Z",
    fill: "#3F2F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.2fd9d78ef6148685795434a9a096f85a.svg";
export { ForwardRef as ReactComponent };